<template>
  <div class="projects-info-list item-list item-report-summary trial-info-table">
    <div
      class="summary-toolbar"
      v-if="title"
    >
      <h2>{{title}}</h2>
    </div>
    <table v-if="freeTrialPackages">
      <thead>
        <tr>
          <th>S. No</th>
          <th>Project Key</th>
          <th>Package Name</th>
          <th>Kind</th>
          <th v-if="isActive">Expires at</th>
          <th v-else>Expired at</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(info, index) in freeTrialPackages"
          :key="info.key"
        >
          <td>
            {{index + 1}}
          </td>
          <td>
            {{info.project.key}}
          </td>
          <td>
            {{info.name}}
          </td>
          <td>
            {{info.expires.kind}}
          </td>
          <td>
            {{$filters.formatDate(info.expires.expires_at)}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

export default {
  props: {
    freeTrialPackages: Array,
    title: {
      type: String,
      default: '',
    },
  },

  computed: {
    isActive() {
      return this.title === 'Active Trial Packages';
    },
  },
};
</script>
<style lang="scss" scoped>
.trial-info-table {
  width: 100%;
  &.item-report-summary {
    table {
      width: 95%;
      padding: 0 size(20);
      margin-right: auto;
      margin-left: auto;
      thead {
        th {
          border-bottom: size(1) solid var(--admin--text-level2);
          p {
            padding: 0;
            text-align: center;
            font-size: size(16);
            &.currency {
              padding: size(15) 0 0;
              text-align: center;
              font-size: size(12);
            }
          }
        }
      }
      tbody {
        tr {
          td {
            border-bottom: size(1) solid var(--admin--text-level2);
            &:nth-child(2), &:nth-child(3) {
              word-break: break-all;
              line-height: size(20);
            }
            span {
              vertical-align: top;
            }
          }
        }
      }
    }
  }
}
</style>
